// extracted by mini-css-extract-plugin
export var advisor = "WISProduct-module--advisor--S5p9j";
export var desc = "WISProduct-module--desc--4xcAE";
export var grid = "WISProduct-module--grid--yGA6q";
export var header = "WISProduct-module--header--SBtZ-";
export var root = "WISProduct-module--root--YginA";